import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatepickerService {
  private activePickerId: string | null = null;
  private closeAll$ = new Subject<string>();

  /**
   * Observable that emits the ID of the datepicker that should stay open
   * All other datepickers should close
   */
  get onCloseOthers$() {
    return this.closeAll$.asObservable();
  }

  /**
   * Register a datepicker as active, closing all others
   * @param id Unique identifier for the datepicker instance
   */
  setActive(id: string): void {
    this.activePickerId = id;
    this.closeAll$.next(id);
  }

  /**
   * Clear the active datepicker
   */
  clearActive(id: string): void {
    if (this.activePickerId === id) {
      this.activePickerId = null;
    }
  }

  /**
   * Check if a specific datepicker is the active one
   */
  isActive(id: string): boolean {
    return this.activePickerId === id;
  }
}

